import { render, staticRenderFns } from "./RecTab.vue?vue&type=template&id=5f66efb8"
import script from "./RecTab.vue?vue&type=script&lang=js"
export * from "./RecTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports